// Chart header component
import React from 'react';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { Select } from 'antd';
import { AppWatch } from '@wajeez-web/core/api-base';
import dayjs from 'dayjs';
export interface ChartHeaderProps {
  title: string;
  plansFilterAction?: (plan: AppWatch.PlanType) => void;
  subscriptionDuration?: AppWatch.SubscriptionDuration | null;
  SubscriptionDurationAction?: (
    duration: AppWatch.SubscriptionDuration | null
  ) => void;
  SubscriptionTypeAction?: (type?: AppWatch.SubscriptionType) => void;
  PurchaseSourceAction?: (source: AppWatch.PurchaseSourceType) => void;
  dates?: Date[];
  subTitle?: string;
  purchaseSource?: AppWatch.PurchaseSourceType;
}

export const ChartHeader: React.FC<ChartHeaderProps> = ({
  title,
  plansFilterAction,
  SubscriptionDurationAction,
  SubscriptionTypeAction,
  PurchaseSourceAction,
  purchaseSource,
  dates,
  subTitle,
  subscriptionDuration,
}) => {
  return (
    <div className="flex flex-row justify-between">
      <div>
        {' '}
        <div className="text-lg font-bold flex space-s-2 items-center ">
          <ReturnTranslatedText text={'charts.title.' + title} />
          {dates && (
            <div className="text-sm text-gray-400 font-normal">
              ( {dayjs(dates[0]).format('YYYY-MM-DD')} -{' '}
              {dayjs(dates[1]).format('YYYY-MM-DD')})
            </div>
          )}
        </div>
        <div className="text-lg font-normal">{subTitle}</div>
      </div>
      <div className="flex space-x-2">
        {' '}
        {plansFilterAction && (
          <Select
            defaultValue={AppWatch.PlanType.All}
            style={{ width: 110 }}
            onChange={(value: AppWatch.PlanType) => plansFilterAction(value)}
            options={[
              { label: 'الكل', value: AppWatch.PlanType.All },
              { label: 'مجاني', value: AppWatch.PlanType.FREEMIUM },
              { label: 'بريميوم', value: AppWatch.PlanType.PREMIUM },
            ]}
          />
        )}
        {SubscriptionDurationAction && (
          <Select
            className="me-2"
            defaultValue={null}
            value={subscriptionDuration}
            style={{ width: 110 }}
            onChange={(value: AppWatch.SubscriptionDuration) =>
              SubscriptionDurationAction(value)
            }
            options={[
              { label: 'الكل', value: null },
              { label: 'شهري', value: AppWatch.SubscriptionDuration.P1M },
              { label: 'سنوي', value: AppWatch.SubscriptionDuration.P1Y },
            ]}
          />
        )}
        {PurchaseSourceAction && (
          <Select
            className="w-[160px]"
            value={purchaseSource}
            onChange={(e) => PurchaseSourceAction(e)}
            options={[
              {
                label: 'CARD',
                value: AppWatch.PurchaseSourceType.CARD_DIRECT,
              },
              { label: 'DCP', value: AppWatch.PurchaseSourceType.DCP_WALLET },
              { label: 'FREE', value: AppWatch.PurchaseSourceType.FREE },
              {
                label: 'INSTALLMENT_PLAN',
                value: AppWatch.PurchaseSourceType.INSTALLMENT_PLAN,
              },
              {
                label: 'INTERNAL',
                value: AppWatch.PurchaseSourceType.INTERNAL,
              },
              {
                label: 'MOBILE_STORE',
                value: AppWatch.PurchaseSourceType.MOBILE_STORE,
              },
              {
                label: 'OFFLINE',
                value: AppWatch.PurchaseSourceType.OFFLINE,
              },
              {
                label: 'VOUCHER',
                value: AppWatch.PurchaseSourceType.VOUCHER,
              },
              { label: 'Other', value: AppWatch.PurchaseSourceType.Other },
            ]}
          />
        )}
        {SubscriptionTypeAction && (
          <Select
            defaultValue={AppWatch.SubscriptionType.New}
            style={{ width: 110 }}
            onChange={(value: AppWatch.SubscriptionType) =>
              SubscriptionTypeAction(value)
            }
            options={[
              { label: 'جديد', value: AppWatch.SubscriptionType.New },
              {
                label: 'تجديد اشتراك',
                value: AppWatch.SubscriptionType.Renewal,
              },
            ]}
          />
        )}
      </div>
    </div>
  );
};
